var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.198,
    height: 14,
    viewBox: "0 0 16.198 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.warning{fill:#f5a623;}\n\t\t"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "warning",
    d: "M17.393,13.533,11.743,4.162a2.527,2.527,0,0,0-4.258,0L1.834,13.533a2.21,2.21,0,0,0-.037,2.21A2.483,2.483,0,0,0,3.963,17h11.3a2.483,2.483,0,0,0,2.166-1.223,2.21,2.21,0,0,0-.037-2.24Zm-7.78.516a.737.737,0,1,1,.737-.737A.737.737,0,0,1,9.614,14.049ZM10.35,11.1a.737.737,0,1,1-1.473,0V8.155a.737.737,0,0,1,1.473,0Z",
    transform: "translate(-1.519 -2.996)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/WarningIcon.d4a8f414104dec707ff09e16d87820d0.svg";
export { ForwardRef as ReactComponent };